export default __webpack_public_path__ + "static/media/signupImage.a64fc8de.png";